export interface ActionsKeyArguments {
  approvalId: string;
  roleName: string;
}

/**
 * Hierarchical query-key factory for the role-scoped Workbench actions list.
 * Keyed on both inputs the BFF requires, so the list re-fetches when either changes.
 */
export const actionsKeys = {
  all: ["workbenchActions"] as const,
  lists: () => [...actionsKeys.all, "list"] as const,
  list: (arguments_: ActionsKeyArguments) => [...actionsKeys.lists(), arguments_] as const,
};
